var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"01_Assets/Icon/UI/Pause"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Chapter-2","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"00_Screen/Chapter-2/1f","transform":"translate(-89.000000, -378.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"Play-Bar","transform":"translate(80.000000, 369.000000)"},React.createElement("g",{"id":"01_Assets/Icon/UI/Play"},React.createElement("polygon",{"id":"Triangle","transform":"translate(18.000000, 18.000000) rotate(90.000000) translate(-18.000000, -18.000000) ","points":"18 9 27 27 9 27"})))))]);
}

Play.defaultProps = {"width":"18px","height":"18px","viewBox":"0 0 18 18","version":"1.1"};

module.exports = Play;

Play.default = Play;
